import DOMPurify from "dompurify";

/**
 * Sanitize an email's HTML body for in-app rendering.
 *
 * DOMPurify defaults are aggressive: scripts, event handlers, javascript:
 * URLs, and dangerous attributes are stripped. We additionally force
 * `target="_blank"` + `rel="noopener noreferrer"` on every link so a
 * clicked-through phishing page can't `window.opener` us back.
 *
 * We accept inline styles and images — staff need formatting and inline
 * client logos to read mails the way they always have. Remote-image
 * blocking (an anti-tracking measure) is a v2 enhancement.
 */
export function sanitizeEmailHtml(html: string): string {
  if (!html) return "";

  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A") {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
  });

  try {
    return DOMPurify.sanitize(html, {
      USE_PROFILES: { html: true },
      WHOLE_DOCUMENT: false,
      SANITIZE_NAMED_PROPS: true,
    });
  } finally {
    DOMPurify.removeAllHooks();
  }
}
